import { HttpError } from './HttpError';

export class NotFoundError extends HttpError {
	constructor(options?: { cause?: unknown }) {
		super('Page not found', 404, 404, options);
	}
}
